import React from "react";
import ReusableDropdown from "../../../../../components/ReusableDropdown";
import { getEmployeeInitials, getShortName } from "../../../utils/nameUtils";

const AttendeesSection = ({
  isOriginator,
  isEditing,
  formData,
  setFormData,
  employeeList,
  suggestionFilter,
  setSuggestionFilter,
  setShowSuggestions,
  addEmployeeFromSuggestion,
  t,
  language,
  theme,
  styles,
  screenSize,
}) => {
  const attendeeCount = formData.attendees
    ? formData.attendees.split(",").filter((e) => e.trim()).length
    : 0;

  return (
    <div
      style={
        styles.formGroup || {
          marginBottom: screenSize.isMobile ? "16px" : "20px",
        }
      }
    >
      <label style={styles.formLabel}>
        {!isOriginator && isEditing
          ? t.eventAttendees
          : `${t.attendees} (${attendeeCount})`}
      </label>

      {isOriginator ? (
        <div style={{ position: "relative" }}>
          <ReusableDropdown
            items={employeeList.filter((emp) => {
              const current = (formData.attendees || "")
                .split(",")
                .map((e) => e.trim().toLowerCase())
                .filter(Boolean);
              return emp.email && !current.includes(emp.email.toLowerCase());
            })}
            value={suggestionFilter}
            onChange={(v) => {
              setSuggestionFilter(v);
              setShowSuggestions(!!v);
            }}
            onSelect={(item) => {
              addEmployeeFromSuggestion(item);
            }}
            getItemKey={(it) => it.email}
            getItemLabel={(it) => `${it.name} `}
            placeholder={t.typeNameEmail}
            theme={theme}
            language={language}
            maxItems={8}
          />
        </div>
      ) : (
        <div
          style={{
            ...styles.formInput,
            background:
              theme === "dark"
                ? "rgba(255,255,255,0.06)"
                : "rgba(255,255,255,0.5)",
            color:
              theme === "dark"
                ? "rgba(255,255,255,0.7)"
                : "rgba(26,26,26,0.7)",
          }}
        >
          {formData.originatorName &&
            formData.originatorName !== t.unknownUser && (
              <>
                {t.organizer}: {getShortName(formData.originatorName, 2)}
                {formData.attendees && formData.attendees.trim() && <br />}
              </>
            )}
          {formData.attendees && formData.attendees.trim() && (
            <>
              {t.attendees}: {formData.attendees}
            </>
          )}
        </div>
      )}

      {/* Attendee Chips */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: screenSize.isMobile ? 6 : 8,
          marginTop: 12,
          flexDirection: language === "ar" ? "row-reverse" : "row",
        }}
      >
        {formData.originatorName &&
          formData.originatorName !== t.unknownUser && (
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: screenSize.isMobile ? 6 : 8,
                padding: screenSize.isMobile ? "6px 10px" : "8px 14px",
                borderRadius: 999,
                fontSize: screenSize.isMobile ? 11 : 13,
                fontWeight: 600,
                background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                color: "#fff",
                border: "2px solid #2e7cba",
                flexDirection: language === "ar" ? "row-reverse" : "row",
              }}
            >
              <div
                style={{
                  width: screenSize.isMobile ? 16 : 20,
                  height: screenSize.isMobile ? 16 : 20,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: screenSize.isMobile ? 8 : 10,
                  fontWeight: 700,
                }}
              >
                {getEmployeeInitials({
                  name: formData.originatorName,
                  email: "",
                })}
              </div>
              {getShortName(formData.originatorName, 2)} ({t.organizer})
            </div>
          )}

        {(formData.attendees || "")
          .split(",")
          .map((email) => email.trim())
          .filter((email) => email.length > 0)
          .map((email, idx) => {
            const employee = employeeList.find(
              (emp) => emp.email.toLowerCase() === email.toLowerCase()
            );
            const exists = !!employee;

            return (
              <div
                key={email + "-" + idx}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: screenSize.isMobile ? 6 : 8,
                  padding: screenSize.isMobile ? "6px 10px" : "8px 14px",
                  borderRadius: 999,
                  fontSize: screenSize.isMobile ? 11 : 13,
                  fontWeight: 600,
                  background: exists
                    ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
                    : "linear-gradient(135deg, #f59e0b, #d97706)",
                  color: "#fff",
                  border: exists ? "2px solid #2e7cba" : "2px solid #d97706",
                  cursor: isOriginator ? "pointer" : "default",
                  boxShadow: exists
                    ? "0 4px 12px rgba(59, 130, 246, 0.3)"
                    : "0 4px 12px rgba(245, 158, 11, 0.3)",
                  transition: "all 0.2s ease",
                  flexDirection: language === "ar" ? "row-reverse" : "row",
                }}
                title={
                  exists
                    ? `${employee.name} - ${employee.position} - ${employee.department}`
                    : language === "ar"
                    ? "بريد إلكتروني خارجي - غير موجود في قاعدة بيانات الموظفين"
                    : "External email - not in employee database"
                }
                onClick={
                  isOriginator
                    ? () => {
                        const remaining = (formData.attendees || "")
                          .split(",")
                          .map((e) => e.trim())
                          .filter(
                            (e) =>
                              e.length > 0 &&
                              e.toLowerCase() !== email.toLowerCase()
                          );
                        setFormData((prev) => ({
                          ...prev,
                          attendees: remaining.join(", "),
                        }));
                      }
                    : undefined
                }
              >
                <div
                  style={{
                    width: screenSize.isMobile ? 16 : 20,
                    height: screenSize.isMobile ? 16 : 20,
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: screenSize.isMobile ? 8 : 10,
                    fontWeight: 700,
                  }}
                >
                  {exists
                    ? getEmployeeInitials(employee)
                    : email[0].toUpperCase()}
                </div>

                <span
                  style={{
                    maxWidth: screenSize.isMobile ? 120 : 180,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {exists ? getShortName(employee.name, 2) : email}
                </span>

                {isOriginator && (
                  <div
                    style={{
                      width: screenSize.isMobile ? 14 : 16,
                      height: screenSize.isMobile ? 14 : 16,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: screenSize.isMobile ? 10 : 12,
                      cursor: "pointer",
                    }}
                  >
                    ×
                  </div>
                )}
              </div>
            );
          })}
      </div>

      {/* Attendees Counter */}
      <div
        style={{
          fontSize: screenSize.isMobile ? 10 : 12,
          color:
            theme === "dark"
              ? "rgba(255,255,255,0.6)"
              : "rgba(26,26,26,0.5)",
          marginTop: 8,
          display: "flex",
          flexDirection: screenSize.isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: screenSize.isMobile ? "flex-start" : "center",
          gap: screenSize.isMobile ? 4 : 0,
          textAlign: language === "ar" ? "right" : "left",
        }}
      >
        <span>
          {attendeeCount}{" "}
          {attendeeCount !== 1 ? t.attendeesPlural : t.attendee}{" "}
          {t.willReceiveInvitations}
        </span>
        {employeeList.length > 0 && (
          <span style={{ fontStyle: "italic" }}>
            {employeeList.length} {t.employeesAvailable}
          </span>
        )}
      </div>
    </div>
  );
};

export default AttendeesSection;
